(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('superadmin', {
            abstract: true,
            parent: 'app'
        });
    }
})();
